/**
 * Registers a new block provided a unique name and an object defining its behavior.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
import { getBlockType } from '@wordpress/blocks';
import { registerBlockType } from '@wordpress/blocks';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * All files containing `style` keyword are bundled together. The code used
 * gets applied both to the front of your site and to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './style.scss';

/**
 * Internal dependencies
 */
import Edit from './edit';
import save from './save';
import metadata from './block.json';
import icons from './icons.js';

const { __ } = wp.i18n;

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
if (!getBlockType(metadata.name)) {
	registerBlockType( metadata.name, {
		title: __(metadata.title, 'smaily-for-wp' ),
		icon: icons.smaily, // The Block icon
		category: "widgets",
		keywords: [__("E-mail"),__("Smaily")],
		attributes: {
			title: {
				type: "string",
				default: __( 'Smaily Newsletter Subscription', 'smaily-for-wp' )
			},
			success_url: {
				type: "string",
				default: ""
			},
			failure_url: {
				type: "string",
				default: ""
			},
			show_name: {
				type: "boolean",
				default: ""
			},
			autoresponder_id: {
				type: "string",
				default: ""
			}
		},
		edit: Edit,
		save: save,
	} );
}